// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".favorite[data-v-658e6cb4]{position:relative;cursor:pointer;font-size:20px;transform:ease-in-out-all 1s}.favorite.icon-star-open[data-v-658e6cb4]{color:var(--muted)}.favorite.icon-star-closed[data-v-658e6cb4]{color:var(--body-text)}", ""]);
// Exports
module.exports = exports;
